<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <div class="total_con">
      <el-form :inline="true">
        <el-form-item label="开户人数:"><p>{{ totalNum.customerTotal }}</p></el-form-item>
        <el-form-item label="激活人数:"><p>{{ totalNum.activeTotal }}</p></el-form-item>
      </el-form>
    </div>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <el-dialog title="详情" :visible.sync="isSlotLevel">
      <!--代理详情-->
      <slotLevel :data="slotLevelData" :nav="slotLevelNav"></slotLevel>
    </el-dialog>
  </div>
</template>

<script>
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import Url from '@/views/proxy/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import slotLevel from '@/views/proxy/adAgent/components/slotLevel.vue'

export default {
  name: 'levelList',
  components: {
    FORM,
    tablePage,
    UPDATE,
    slotLevel
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '代理編碼', field: 'code' },
          { click: '当天' },
          { click: '当周' },
          { click: '当月' },
          { click: '最近三个月' },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.levelList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '一级代理编码', field: 'agentCode' },
          { title: '一级代理名称', field: 'agentName' },
          {
            title: '开始时间', field: 'startTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '结束时间', field: 'endTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '总开户人数', field: 'customerNumberTotal' },
          { title: '总激活人数', field: 'activeTotal' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.detail'),
                click: 'detail',
                type: 'primary',
                icon: 'el-icon-detail', hidden: (data, full) => {
                  return full.statistics.length == 0
                }
              }
            ]
          }
        ]
      },
      totalNum: {},
      isSlotLevel: false,
      slotLevelNav: [
        { name: '代理編碼', id: 'agentCode' },
        { name: '代理名称', id: 'agentName' },
        { name: '开始时间', id: 'startTime' },
        { name: '结束时间', id: 'endTime' },
        { name: '直客开户人数', id: 'customerNumberTotal' },
        { name: '直客激活人数', id: 'activeTotal' }
      ],
      slotLevelData: []
    }
  },
  methods: {
    dateToString(data) {
      let date = data.replace(/-/g, '/') //必须把日期'-'转为'/'
      return new Date(date).getTime()
    },
    formatDate(data) {
      var yy = data.getFullYear()      //年
      var mm = data.getMonth() + 1     //月
      var dd = data.getDate()          //日
      var clock = yy + '-'
      if (mm < 10) clock += '0'
      clock += mm + '-'
      if (dd < 10) clock += '0'
      clock += dd + ' '
      return clock
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('当天' == clickName) {
        let now = new Date()
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = now.getTime()
        this.$refs.childTable.defaultQueryData(data)
      } else if ('当周' == clickName) {
        let now = new Date()
        let day = now.getDay()
        if (day == 0) {
          day = 7
        }
        now.setDate(now.getDate() - day + 1)
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultQueryData(data)
      } else if ('当月' == clickName) {
        let now = new Date()
        now.setDate(1)
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultQueryData(data)
      } else if ('最近三个月' == clickName) {
        let now = new Date()
        data.startTime = new Date(now.setMonth(now.getMonth() - 3)).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultQueryData(data)
      }
      this.getTotalNum(data)
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'detail') {
        this.isSlotLevel = true
        let data = JSON.parse(JSON.stringify(row.agentCustomers))
        for (const i in data) {
          for (const j in data[i].agentCustomerList) {
            data[i].agentCustomerList[j].startTime = DateUtil.formatDate(data[i].agentCustomerList[j].startTime, 'yyyy-MM-dd hh:mm:ss')
            data[i].agentCustomerList[j].endTime = DateUtil.formatDate(data[i].agentCustomerList[j].endTime, 'yyyy-MM-dd hh:mm:ss')
          }
        }
        this.slotLevelData = data
      }
    },
    getTotalNum(option) {
      this.$axios.get(Url.adAgent.customerStatistics, { params: option }).then(res => {
        if (res.code == 0) {
          this.totalNum = res.result
        }
      })
    },
    findMax(data) {
      var maxArr = {}
      if (data.length === 1) {
        maxArr = data[0]
      } else {
        maxArr = data[0]
        for (const i in data) {
          if (data[i].statistics.length > maxArr.statistics.length) {
            maxArr = data[i]
          }
        }
      }
      return maxArr
    },
    editTableNav() {
      this.$axios.get(Url.adAgent.levelList).then(res => {
        if (res.code == 0) {
          let arr = {}, col = [], maxArr = {}
          if (res.result) {
            let data = res.result.list
            if (data.length > 0) {
              maxArr = this.findMax(data)
              for (const j in maxArr.statistics) {
                arr = {
                  title: maxArr.statistics[j].level + '级代理數',
                  field: 'statistics',
                  render: (data, full) => {
                    for (const i in data) {
                      if (data[i].level == maxArr.statistics[j].level) {
                        return data[i].total
                      }
                    }
                  }
                }
                col.push(arr)
              }
              this.pageData.cols = this.pageData.cols.concat(col)
            }
          }
        }
      })
    }
  },
  mounted() {
    this.getTotalNum({})
    this.editTableNav()
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}
.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}
.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
